export default function VendorResourceController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpSharedModelService,
  confirmDialog,
  editVendorDialog,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.hasData = false;
  vm.handleDelete = _handleDelete;
  vm.handleEdit = _handleEdit;

  /** **************************************************
   * Event Handlers
   */

  function _handleEdit($event, vendor) {
    return _showEditVendorDialog($event, { vendor });
  }

  function _handleDelete($event, vendorResource) {
    ssDialogService.dialogs.bcp.confirmDeleteVendorResourceDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Vendor Resource?',
        message: `Are you sure you want to delete the Vendor Resource "${vendorResource.vendor.name}"?`,
        handleYesClick() {
          _deleteVendorResource(vendorResource.assessmentVendorResourceId);
        },
        handleNoClick: _closeConfirmDeleteDialog,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteVendorResourceDialog);
  }

  /** **************************************************
   * Private Functions
   */

  function _deleteVendorResource(assessmentVendorResourceId) {
    loaderService.showViewLoader = true;
    return bcpSharedModelService.deleteVendorResource(assessmentVendorResourceId)
      .then(() => {
        alerts.success('The Vendor Resource has been deleted successfully.');
        $rootScope.$broadcast('loadVendorResources', assessmentVendorResourceId);
      }).catch(() => {
        alerts.error('Error occurred while deleting Vendor Resource.');
      }).finally(() => {
        loaderService.showViewLoader = false;
        return _closeConfirmDeleteDialog();
      });
  }

  function _showEditVendorDialog($event, locals) {
    ssDialogService.dialogs.bcp.editVendorDialog = ssDialogService.alert(
      editVendorDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editVendorDialog);
  }

  function _closeConfirmDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteVendorResourceDialog);
  }
}

VendorResourceController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpSharedModelService',
  'confirmDialog',
  'bcp.editVendorDialog',
  'loaderService',
  'ssDialogService',
];
